import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <AppSection />
        <TopicsSection />
        <AboutSection />
        <UpdatesSection />
        <MediaSection />
        <CommentsSection />
        <ContactSection />
        <RankingSection />
        <CarouselSection />
        <FAQSection />
        <CardsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}